/**
 * The postcode map is rather bulky, import it only where required via a lazy-laoded module.
 */
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { PostcodeMapLondonComponent } from '../../components/manage-postcodes/postcode-map-london.component';
import { PostcodeMapUKComponent } from '../../components/manage-postcodes/postcode-map-uk.component';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';

const components = [PostcodeMapLondonComponent, PostcodeMapUKComponent];

@NgModule({
  imports: [VmeCommonModule, VmePipesModule, VmeDirectivesModule, VMEComponentsModule],
  declarations: [...components],
  exports: [...components],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PostcodeMapsModule {}
